/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClearBranchRequest
 */
export interface ClearBranchRequest {
    /**
     * 
     * @type {string}
     * @memberof ClearBranchRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the ClearBranchRequest interface.
 */
export function instanceOfClearBranchRequest(value: object): value is ClearBranchRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function ClearBranchRequestFromJSON(json: any): ClearBranchRequest {
    return ClearBranchRequestFromJSONTyped(json, false);
}

export function ClearBranchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClearBranchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

  export function ClearBranchRequestToJSON(json: any): ClearBranchRequest {
      return ClearBranchRequestToJSONTyped(json, false);
  }

  export function ClearBranchRequestToJSONTyped(value?: ClearBranchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
    };
}

